module.exports = __webpack_public_path__ + "static/cleancode-102d22176228636dfe2d538eac72526c.png";